import 'requestidlecallback-polyfill'

// TODO: сделать это Suspense чтобы грузить одновременно с другими запросами
export const applyPolyfills = () => {
  const polyfills: Promise<unknown>[] = []

  if (!('allSettled' in Promise)) {
    polyfills.push(import(/* webpackChunkName: "promise-all-settled" */ 'core-js/modules/es.promise.all-settled'))
  }

  if (!('replaceAll' in String.prototype)) {
    polyfills.push(
      import(/* webpackChunkName: "string-prototype-replaceAll" */ 'core-js/modules/es.string.replace-all'),
    )
  }

  if (!('padStart' in String.prototype)) {
    polyfills.push(import(/* webpackChunkName: "string-prototype-padStart" */ 'core-js/modules/es.string.pad-start'))
  }

  if (!('at' in Array.prototype)) {
    polyfills.push(import(/* webpackChunkName: "array-prototype-at" */ 'core-js/modules/es.array.at'))
  }

  return Promise.all(polyfills)
}
